import { render } from "./vadialog.vue?vue&type=template&id=9bd6f122"
import script from "./vadialog.vue?vue&type=script&lang=js"
export * from "./vadialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-admin-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__